/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CalendarioItemDto } from '../../models/calendario-item-dto';

export interface ApiCalendarioCalendarioListGet$Params {}

export function apiCalendarioCalendarioListGet(
    http: HttpClient,
    rootUrl: string,
    params?: ApiCalendarioCalendarioListGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<Array<CalendarioItemDto>>> {
    const rb = new RequestBuilder(rootUrl, apiCalendarioCalendarioListGet.PATH, 'get');
    if (params) {
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<Array<CalendarioItemDto>>;
        }),
    );
}

apiCalendarioCalendarioListGet.PATH = '/api/calendario/calendario-list';
